<template>
  <div>
    <about-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :titleObj="titleObj"
    >
    </about-header>
    <about-center :honorList="honorData" :teamList="teamData" :copyList="copyData" ref="center"></about-center>
    <about-footer :bottom="bottom" :bottomInfo="bottomInfo"></about-footer>
  </div>
</template>

<script>
import AboutHeader from '@/components/mobile/Header'
import AboutCenter from '@/components/mobile/AboutCenter'
import AboutFooter from '@/components/mobile/Footer'
export default {
  name: 'case',
  data() {
    return {
      topStyle: "",
      actIndex: 8,
      imgList: [],
      bottom: {},
      logo: '',
      bottomInfo: {},
      honorData: [
        {
          id: 0,
          nav: '奖项',
          child: [],
        },
        {
          id: 1,
          nav: '合作单位',
          child: [],
        },
        {
          id: 2,
          nav: '战略合作',
          child: [],
        },
        {
          id: 3,
          nav: '合作单位',
          child: [],
        },
        {
          id: 4,
          nav: '其他荣誉',
          child: [],
        },
      ],
      teamData: [],
      copyData: [],
      titleObj: {
        id: 8,
        title: "恭谦  诚信  协作  超越",
        desc: "以匠为局，成就自我\n匠心研发，倾力服务",
      },
      // background: require("../../static/images/about_mobile/banner.png"),
    }
  },
  components: {
    AboutHeader,
    AboutCenter,
    AboutFooter,
  },
  mounted() {
    this.Pc_Mobile()
    this.getPageData()
    this.getHonorData()
    this.getTeamData()
    this.getCopyData()
    this.getHeaderImage()

  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push('/m_about');
      } else {
        this.$router.push('/about');
      }
    },
    getPageData() {
      this.$http.post('home/index/m_aboutpag', null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0]
        this.logo = this.bottom.logo
        // this.topStyle = "background-image:url('" + this.background + "')"
        this.bottomInfo = res.data.contact[0]
      })
    },
    getHonorData() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/enterprise_glory", null, (res) => {
        // console.log(res, "honor");
        if (res.code == 1) {
          for (var i = 0; i <= res.data.length-1; i++) {
            if (res.data[i].type == 1) {
              this.honorData[0].child.push({
                id: i,
                content: res.data[i].content
              })
            } else if (res.data[i].type == 2) {
              this.honorData[1].child.push({
                id: i,
                content: res.data[i].content
              })
            } else if (res.data[i].type == 3) {
              this.honorData[2].child.push({
                id: i,
                content: res.data[i].content
              })
            } else if (res.data[i].type == 4) {
              this.honorData[3].child.push({
                id: i,
                content: res.data[i].content
              })
            } else {
              this.honorData[4].child.push({
                id: i,
                content: res.data[i].content
              })
            }
          }
        }
      });
    },
    getTeamData() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/team_style", null, (res) => {
        // console.log(res, "team");
        if (res.code == 1) {
          this.teamData = res.data;
          this.$nextTick(() => {
              this.$refs.center.freshSwiper();
            });
        }
      });
    },
    getCopyData() {
      this.$http.post("https://eartisanapplets.wsandos.com//api/index/software_copyright", null, (res) => {
        // console.log(res, "copy");
        if (res.code == 1) {
          this.copyData =  res.data;
        }
      });
    },
    getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle =
              "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
  },
  computed: {
    sort() {
      if (!this.developList) {
        return
      }
      var object = {}
      var pages = []
      var list = this.developList
      for (var i = 0; i < list.length; i++) {
        if (!object[list[i].year]) {
          object[list[i].year] = []
        }
        object[list[i].year].push(list[i])
      }
      for (var item in object) {
        var i = {}
        i.year = item
        i.content = object[item]
        pages.unshift(i)
      }
      return pages
    }
  }
}
</script>

<style lang="stylus" scoped></style>


// WEBPACK FOOTER //
// src/views/mobile/About.vue